// extracted by mini-css-extract-plugin
export default {"home":"Home_home__9Ke73","buttons":"Home_buttons__TWBbB","reports":"Home_reports__HYoB7"};